// extracted by mini-css-extract-plugin
export default {"button":"Button_button__l+Ah-","text":"Button_text__vxQem","leftIcon":"Button_leftIcon__WEFeY","rightIcon":"Button_rightIcon__E74q-"};